import script from "./FMSIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./FMSIndex.vue?vue&type=script&setup=true&lang=js"

import "./FMSIndex.vue?vue&type=style&index=0&id=6f10ef04&scoped=true&lang=css"

import exportComponent from "/Users/Ios/Documents/project/FrontEnd/wk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f10ef04"]])

export default __exports__